/* eslint-disable */

import React from 'react';
import { transformProxies } from './helpers';
import Home from '../modules/home';

const scripts = [
  {
    loading: Promise.resolve(
      'Webflow.push(function(){$("input").length&&$("input").each(t=>{var u=$(this).attr("custom-value");u&&$(this).val(u)})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      'jQuery(function(t){t(".switch > input").on("change",function(){t(this).is(":checked")?t("body .instructor-label").attr("style","color:rgb(36, 103, 235)!important;"):t("body .instructor-label").attr("style","color:inherit")})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      'jQuery(function(t){t(".history-menu-rename-btn").on("click",function(){var e=t(this).closest(".history-element").find(".history-element-label").text();t(".modal.rename-history-modal form input.rename-chat-form-input").val(removeSpaceFromText(e))}),t(".history-menu-pin-btn").on("click",function(){var e=t(this).closest(".history-element").find(".history-element-label").text();t(".modal.pin-history-modal form input.rename-chat-form-input").val(removeSpaceFromText(e))})});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      'jQuery(function(e){e(".modal.add-new-prompt-modal .modal-header form input.add-new-prompt-input-title").val("Untitled Prompt")}),jQuery(function(n){n(".modal.edit-mentor-modal .menu-container .menu-element-block:not(.no-border-bottom-on-click)").on("click",function(e){e.preventDefault(),n(".modal.edit-mentor-modal .menu-container .menu-element-block").removeClass("current"),n(this).addClass("current")})}),jQuery(function(n){n(".modal.mentor-creation-modal .menu-container .menu-element-block:not(.no-border-bottom-on-click)").on("click",function(e){e.preventDefault(),n(".modal.mentor-creation-modal .menu-container .menu-element-block").removeClass("current"),n(this).addClass("current")})}),jQuery(function(e){e(".top-header-closer-container").on("click",function(){e(this).closest(".site-top-header").addClass("hidden")})}),jQuery(function(e){e(".interface-mentor-name-input").val("IBL AI Mentor Pro"),e(".mentor-default-prompt1-textarea").val("Generate a daily study schedule for the next week, including specific times for each subject and any breaks or activities planned"),e(".interface-welcome-textarea").val("I’m IBL AI Mentor, your AI helpful assistant. Not sure where to start? You can try:")});'
    ),
    isAsync: false,
  },
];

let Controller;

class IndexView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/IndexController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = IndexView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '650305782bc61751e5765214';
    htmlEl.dataset['wfSite'] = '650305782bc61751e5765211';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      IndexView.Controller !== IndexView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/custom-styles.css);
          @import url(/css/normalize.css);
          @import url(/css/components.css);
          @import url(/css/ibl-aimentorpro-v2.css);
          @import url(/custom-assets/custom.css);


          @supports (-webkit-overflow-scrolling: touch) {
             input:focus, textarea:focus {
               font-size: 16px;
             }
          }



          .guided-question-block-old{
          	width:calc(100% - 30px)!important;
          }
          body.dark-mode .modal .modal-container{
          	border: solid 1px #ffffff75;
          }
          .menu-container .menu-element-block.current .menu-element-bt-border{
          	border-color: #2467eb!important;
          }
          .ai-response-text-container :is(h1, h2, h3, h4, h5, h6){
          	margin-top:0px;
            margin-bottom:0px;
          }
          .ai-response-text-container pre {
              display: block;
              padding: 9.5px;
              margin: 0 0 10px;
              font-size: 13px;
              line-height: 1.42857143;
              color: #333;
              word-break: break-all;
              word-wrap: break-word;
              background-color: #f5f5f5;
              border: 1px solid #ccc;
              border-radius: 4px;
          }
          .ai-response-container-content{
            word-break: break-word;
          }
          .ai-response-text-container td, .ai-response-text-container th {
              background-color: #f9f9f9;
              padding: 8px;
              line-height: 1.42857143;
              vertical-align: top;
              border-top: 1px solid #ddd;
          }
          .ai-response-text-container th{
          	  vertical-align: bottom;
              border-bottom: 2px solid #ddd;
          }
          .ai-response-text-container img {
              max-width: 35%;
          }
          .audio-chat-mentor-image.is-speaking {
            animation: zoomInOut 2s linear infinite;
          }
          @keyframes zoomInOut {
            0% {
              transform: scale3d(1, 1, 1);
            }
            50% {
              transform: scale3d(0.93, 0.93, 0.93);
            }
            100% {
              transform: scale3d(1, 1, 1);
            }
          }
        `,
          }}
        />
        <span className="af-view">
          <Home />
        </span>
      </span>
    );
  }
}

export default IndexView;

/* eslint-enable */
